module.exports = __webpack_public_path__ + "static/media/map-point-hover.19bd6276.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-point-hover.png
// module id = 1132
// module chunks = 0